import { produce } from 'immer'
import type { State } from '../typings'

export type SetRequireACWOppSchedulingAction = {
  type: 'setRequireACWOppScheduling'
  payload: boolean
}

export const setRequireACWOppSchedulingAction = (
  state: State,
  payload: SetRequireACWOppSchedulingAction['payload'],
) =>
  produce(state, (draft) => {
    draft.requireACWOppsSchedulingService = payload
  })

export const setRequireACWOppSchedulingActionCreator = (
  payload: SetRequireACWOppSchedulingAction['payload'],
): SetRequireACWOppSchedulingAction => ({
  type: 'setRequireACWOppScheduling',
  payload,
})
